import * as React from "react";
import {Button} from "react-bootstrap";
import {FormattedMessage, InjectedIntlProps, injectIntl} from "react-intl";
import {RouteComponentProps, withRouter} from "react-router";
import {LcdIcon} from "../common/ui/icon/LcdIcon";
import {ImportedData} from "./model";

export interface OpenFolderButtonOwnProps {
    data: ImportedData;
}

type OpenFolderButtonProps = OpenFolderButtonOwnProps & InjectedIntlProps & RouteComponentProps;

class OpenFolderButtonComponent extends React.Component<OpenFolderButtonProps, unknown> {

    constructor(props: OpenFolderButtonProps) {
        super(props);

        this.state = {};
    }

    render() {
        const {data} = this.props;

        if (data.type !== "folder") {
            return null;
        }

        return (
            <React.Fragment>
                <Button className="actionBarItem" onClick={this.open}>
                    <LcdIcon icon="folder-open"/>
                    <FormattedMessage id="studio.data.data-detail-page.open-folder" defaultMessage="Open Folder"/>
                </Button>
            </React.Fragment>
        );
    }

    private open = () => {
        const {history, data} = this.props;

        history.push(`/data?folder=${encodeURIComponent(data.id)}`);
    };
}

export const OpenFolderButton = withRouter(injectIntl(OpenFolderButtonComponent));